export default __webpack_public_path__ + "static/media/mysql.a4f9bc60.png";